/**
 * NotFoundPage — the root route's notFoundComponent.
 * Rendered (inside RootLayout's chrome) for any URL that does not match a
 * defined route. Marked noindex to prevent search engines from indexing
 * missing pages.
 */
import { Helmet } from 'react-helmet-async';
import { Link } from '@tanstack/react-router';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found — The Artificer's AI</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="section-pad bg-surface text-ink-50 min-h-[60vh] flex items-center justify-center">
        <div className="text-center max-w-md">
          <h1 className="text-display-lg font-display font-semibold mb-4">Page not found</h1>
          <p className="text-body text-ink-200 mb-8">
            The page you are looking for does not exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono text-mono-sm text-brand-blue-bright hover:text-brand-blue-pale transition-colors"
          >
            Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
